var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.7092H21M5 21.7092V5.70923C5 5.1788 5.21071 4.67009 5.58579 4.29501C5.96086 3.91994 6.46957 3.70923 7 3.70923H17C17.5304 3.70923 18.0391 3.91994 18.4142 4.29501C18.7893 4.67009 19 5.1788 19 5.70923V21.7092M9 21.7092V17.7092C9 17.1788 9.21071 16.6701 9.58579 16.295C9.96086 15.9199 10.4696 15.7092 11 15.7092H13C13.5304 15.7092 14.0391 15.9199 14.4142 16.295C14.7893 16.6701 15 17.1788 15 17.7092V21.7092M10 9.70923H14M12 7.70923V11.7092",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutions);
export default __webpack_public_path__ + "static/media/institutions.1338156648ad6ceb5dba142e36cba290.svg";
export { ForwardRef as ReactComponent };